import * as core from '../../../../../../../core'

import { query } from './engagements-table.query'

export const RESOURCE = {
  payload: {
    alias: 'engagements-table',
    description: 'Table used to display and explore engagements',
    name: 'Engagements Table',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
